import styled from 'styled-components';
import { mediaQueries } from '@oneboard/deviceDetect';

export const StyledDeviceDetectPage = styled.div.attrs(props => ({
  className: props.className
}))`
  min-height: 100vh;
  height: 100%;
  width: 100%;
  background-color: #2E343F;
  overflow-y: scroll;
  
  .container {
    max-width: 768px;
    width: 100%;
    padding: 20px 16px;
    margin: auto; 
  }

  ${mediaQueries.small} {
    .container {
      padding: 20px 16px 152px;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .logo {
      width: 217.25px;
      img {
        width: 100%;
      }
    }

    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 35px;
      color: #fff;
      margin-top: 0;
      margin-left: 4px;
    }
    
  ${mediaQueries.small} {
      flex-direction: column;
      .title {
        margin-top: 4px;
      }
    }
  }

  .stepContent {
    margin-top: 24px;
  }
`;